import { useMutation } from '@tanstack/react-query';
import { queryClient, queryKeys } from 'configs';
import { useParticipantsPersonEventsApi } from 'services';

export const useUpdatePerson = () => {
  const { updatePerson } = useParticipantsPersonEventsApi();

  return useMutation({
    mutationFn: updatePerson,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.getPerson]
      });
    }
  });
};
